var render = function () {
  var _vm$shippingInfo, _vm$shippingInfo$hub, _vm$shippingInfo$hub$, _vm$shippingInfo2, _vm$shippingInfo2$hub, _vm$shippingInfo2$hub2, _vm$selectedPackageCa, _vm$shippingInfo19, _vm$shippingInfo19$re, _vm$shippingInfo20, _vm$shippingInfo20$pa, _vm$shippingInfo21, _vm$shippingInfo21$pi, _vm$shippingInfo22, _vm$shippingInfo22$se, _vm$shippingInfo23, _vm$shippingInfo23$se, _vm$shippingInfo24, _vm$shippingInfo24$se, _vm$shippingInfo25, _vm$shippingInfo25$se, _vm$shippingInfo26, _vm$shippingInfo26$re, _vm$shippingInfo27, _vm$shippingInfo27$re, _vm$shippingInfo28, _vm$shippingInfo29, _vm$selectedPackageDe7, _vm$selectedPackageDe8, _vm$shippingInfo30, _vm$shippingInfo30$se, _vm$selectedPackageDe9, _vm$selectedPackageDe10, _vm$shippingInfo31, _vm$user, _vm$user2, _vm$selectedPackageDe11, _vm$selectedPackageDe12, _vm$selectedPackageDe13, _vm$selectedPackageDe14, _vm$selectedPackageDe15;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "create-order"
  }, [_c('div', {
    staticClass: "flex items-center bg-neutral-700 py-10 px-40 stepper relative mdmax:px-4 mdmax:text-center mdmax:gap-2 mdmax:-mx-4 mdmax:py-6 mdmax:items-stretch"
  }, [_c('div', {
    staticClass: "flex-1 py-2 px-6 rounded bg-neutral-600 mdmax:pl-3 mdmax:pr-3",
    class: {
      arrow: !_vm.isMobile
    }
  }, [_c('p', {
    staticClass: "text-sm font-medium text-white"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepOne.title')))]), _c('p', {
    staticClass: "text-xs text-white"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepOne.desc')))])]), _c('div', {
    staticClass: "flex-1 py-2 pl-10 pr-6 bg-primary-100 rounded mdmax:pl-3 mdmax:pr-3",
    class: {
      arrow: !_vm.isMobile
    }
  }, [_c('p', {
    staticClass: "text-sm font-medium "
  }, [_vm._v("Logistik & Pembayaran")]), _c('p', {
    staticClass: "text-xs text-neutral-500"
  }, [_vm._v("Pilih logistik dan bayar")])])]), _c('div', {
    staticClass: "flex bg-white shadow-border-b pb-px mdmax:flex-col w-full"
  }, [_c('div', {
    staticClass: "w-2/5 shadow-border-r pr-px mdmax:w-full"
  }, [_c('div', {
    staticClass: "py-3 px-8 flex gap-9 items-center bg-neutral-200 mdmax:px-4"
  }, [_c('Box2', {
    attrs: {
      "color": "primary-500"
    }
  }), _c('div', {
    staticClass: "flex flex-col"
  }, [_c('p', {
    staticClass: "text-xs"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepTwo.show')) + " " + _vm._s(Object.keys(_vm.deliveryServiceByGroup).length) + " " + _vm._s(_vm.$t('order.createOrder.stepTwo.deliveryService')))]), _c('p', {
    staticClass: "font-bold"
  }, [_vm._v(_vm._s((_vm$shippingInfo = _vm.shippingInfo) === null || _vm$shippingInfo === void 0 ? void 0 : (_vm$shippingInfo$hub = _vm$shippingInfo.hub) === null || _vm$shippingInfo$hub === void 0 ? void 0 : (_vm$shippingInfo$hub$ = _vm$shippingInfo$hub.origin) === null || _vm$shippingInfo$hub$ === void 0 ? void 0 : _vm$shippingInfo$hub$.district) + " - " + _vm._s((_vm$shippingInfo2 = _vm.shippingInfo) === null || _vm$shippingInfo2 === void 0 ? void 0 : (_vm$shippingInfo2$hub = _vm$shippingInfo2.hub) === null || _vm$shippingInfo2$hub === void 0 ? void 0 : (_vm$shippingInfo2$hub2 = _vm$shippingInfo2$hub.destination) === null || _vm$shippingInfo2$hub2 === void 0 ? void 0 : _vm$shippingInfo2$hub2.district))])])], 1), _c('div', {
    staticClass: "group px-5"
  }, [_vm.recommendedDeliveryServices.length > 0 ? [_c('div', {
    staticClass: "mb-8 p-4 bg-secondary-50 border border-secondary-300 rounded-lg relative overflow-hidden shadow-sm"
  }, [_c('div', {
    staticClass: "absolute top-0 right-0 bg-secondary-500 text-white text-[10px] font-bold px-3 py-1 rounded-bl-lg tracking-wider uppercase"
  }, [_vm._v(" Rekomendasi ")]), _c('div', {
    staticClass: "flex flex-col gap-3"
  }, _vm._l(_vm.recommendedDeliveryServices, function (service, idx) {
    var _vm$selectedPackageDe, _vm$selectedPackageDe2, _vm$selectedPackageDe3, _vm$selectedPackageDe4, _vm$shippingInfo3, _vm$shippingInfo3$rec, _vm$shippingInfo4, _vm$shippingInfo4$rec, _vm$shippingInfo5, _vm$shippingInfo5$rec, _vm$shippingInfo6, _vm$shippingInfo6$rec, _vm$shippingInfo9, _vm$shippingInfo9$rec, _vm$shippingInfo10, _vm$shippingInfo10$re, _service$package, _service$package$retu;

    return _c('div', {
      key: 'rec-service' + idx,
      staticClass: "flex justify-between items-center py-3 px-4 rounded-lg cursor-pointer transition-all duration-200 border bg-white",
      class: {
        'border-secondary-500 shadow-md ring-1 ring-secondary-500': ((_vm$selectedPackageDe = _vm.selectedPackageDelivery) === null || _vm$selectedPackageDe === void 0 ? void 0 : (_vm$selectedPackageDe2 = _vm$selectedPackageDe.package) === null || _vm$selectedPackageDe2 === void 0 ? void 0 : _vm$selectedPackageDe2.id) === service.package.id,
        'border-neutral-200 hover:border-secondary-300 hover:shadow-sm': ((_vm$selectedPackageDe3 = _vm.selectedPackageDelivery) === null || _vm$selectedPackageDe3 === void 0 ? void 0 : (_vm$selectedPackageDe4 = _vm$selectedPackageDe3.package) === null || _vm$selectedPackageDe4 === void 0 ? void 0 : _vm$selectedPackageDe4.id) !== service.package.id,
        'bg-neutral-100 opacity-60 cursor-not-allowed border-neutral-200': parseInt((_vm$shippingInfo3 = _vm.shippingInfo) === null || _vm$shippingInfo3 === void 0 ? void 0 : (_vm$shippingInfo3$rec = _vm$shippingInfo3.receiver) === null || _vm$shippingInfo3$rec === void 0 ? void 0 : _vm$shippingInfo3$rec.weight) < parseInt(service.package.minimum_weight) || parseInt((_vm$shippingInfo4 = _vm.shippingInfo) === null || _vm$shippingInfo4 === void 0 ? void 0 : (_vm$shippingInfo4$rec = _vm$shippingInfo4.receiver) === null || _vm$shippingInfo4$rec === void 0 ? void 0 : _vm$shippingInfo4$rec.weight) > parseInt(service.package.maximum_weight) || parseInt(service.package.final_cost) <= 0
      },
      attrs: {
        "disabled": parseInt((_vm$shippingInfo5 = _vm.shippingInfo) === null || _vm$shippingInfo5 === void 0 ? void 0 : (_vm$shippingInfo5$rec = _vm$shippingInfo5.receiver) === null || _vm$shippingInfo5$rec === void 0 ? void 0 : _vm$shippingInfo5$rec.weight) < parseInt(service.package.minimum_weight) || parseInt((_vm$shippingInfo6 = _vm.shippingInfo) === null || _vm$shippingInfo6 === void 0 ? void 0 : (_vm$shippingInfo6$rec = _vm$shippingInfo6.receiver) === null || _vm$shippingInfo6$rec === void 0 ? void 0 : _vm$shippingInfo6$rec.weight) > parseInt(service.package.maximum_weight) || parseInt(service.package.final_cost) <= 0
      },
      on: {
        "click": function click($event) {
          var _vm$shippingInfo7, _vm$shippingInfo7$rec, _vm$shippingInfo8, _vm$shippingInfo8$rec;

          parseInt((_vm$shippingInfo7 = _vm.shippingInfo) === null || _vm$shippingInfo7 === void 0 ? void 0 : (_vm$shippingInfo7$rec = _vm$shippingInfo7.receiver) === null || _vm$shippingInfo7$rec === void 0 ? void 0 : _vm$shippingInfo7$rec.weight) >= parseInt(service.package.minimum_weight) && parseInt((_vm$shippingInfo8 = _vm.shippingInfo) === null || _vm$shippingInfo8 === void 0 ? void 0 : (_vm$shippingInfo8$rec = _vm$shippingInfo8.receiver) === null || _vm$shippingInfo8$rec === void 0 ? void 0 : _vm$shippingInfo8$rec.weight) <= parseInt(service.package.maximum_weight) && parseInt(service.package.final_cost) > 0 ? _vm.selectPackage(service.package, service) : null;
        }
      }
    }, [_c('div', {
      staticClass: "flex gap-4 items-center"
    }, [_c('div', {
      staticClass: "flex justify-center items-center w-16 h-12 bg-neutral-50 rounded p-1 border border-neutral-100"
    }, [service.logo ? _c('img', {
      staticClass: "max-h-10 object-contain",
      attrs: {
        "src": service.logo,
        "alt": service.name
      }
    }) : _c('LogisticPlaceholder', {
      attrs: {
        "logisticName": service.name
      }
    })], 1), _c('div', [_c('p', {
      staticClass: "text-sm font-semibold text-neutral-800"
    }, [_vm._v(" " + _vm._s(service.package.name) + " ")]), parseInt(service.package.final_cost) <= 0 ? [_c('p', {
      staticClass: "text-xs text-red-500 mt-0.5"
    }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepTwo.unavailableService')))])] : parseInt((_vm$shippingInfo9 = _vm.shippingInfo) === null || _vm$shippingInfo9 === void 0 ? void 0 : (_vm$shippingInfo9$rec = _vm$shippingInfo9.receiver) === null || _vm$shippingInfo9$rec === void 0 ? void 0 : _vm$shippingInfo9$rec.weight) < parseInt(service.package.minimum_weight) ? [_c('p', {
      staticClass: "text-xs text-neutral-500 mt-0.5"
    }, [_vm._v(" " + _vm._s(_vm.$t('order.createOrder.stepTwo.minimumWeight')) + " " + _vm._s(service.package.name) + " " + _vm._s(service.package.minimum_weight) + " Kg ")])] : parseInt((_vm$shippingInfo10 = _vm.shippingInfo) === null || _vm$shippingInfo10 === void 0 ? void 0 : (_vm$shippingInfo10$re = _vm$shippingInfo10.receiver) === null || _vm$shippingInfo10$re === void 0 ? void 0 : _vm$shippingInfo10$re.weight) > parseInt(service.package.maximum_weight) ? [_c('p', {
      staticClass: "text-xs text-neutral-500 mt-0.5"
    }, [_vm._v(" " + _vm._s(_vm.$t('order.createOrder.stepTwo.maximumWeight')) + " " + _vm._s(service.package.name) + " " + _vm._s(service.package.maximum_weight) + " Kg ")])] : [_c('p', {
      staticClass: "text-xs text-secondary-600 mt-0.5 font-medium flex items-center gap-1"
    }, [_c('Time', {
      attrs: {
        "color": "secondary-600",
        "width": "12",
        "height": "12"
      }
    }), _vm._v(" " + _vm._s(service.package.est_delivery_time_range_min) + " - " + _vm._s(service.package.est_delivery_time_range_max) + " ")], 1)]], 2)]), parseInt(service.package.final_cost) > 0 ? _c('div', {
      staticClass: "flex flex-col justify-end items-end text-right"
    }, [service.package.final_cost !== service.package.shipment_cost ? _c('p', {
      staticClass: "text-xs text-neutral-400 line-through mb-0.5"
    }, [_vm._v(" " + _vm._s(_vm._f("currencyFormat")(service.package.shipment_cost)) + " ")]) : _vm._e(), _c('p', {
      staticClass: "text-base font-bold text-primary-600"
    }, [_vm._v(" " + _vm._s(_vm._f("currencyFormat")(service.package.final_cost)) + " "), _vm.shippingInfo.is_require_pod ? [_c('span', {
      staticClass: "text-xs text-neutral-500 font-normal block"
    }, [_vm._v(" + " + _vm._s(_vm._f("currencyFormat")((_service$package = service.package) === null || _service$package === void 0 ? void 0 : (_service$package$retu = _service$package.return_delivery_service_packages[0]) === null || _service$package$retu === void 0 ? void 0 : _service$package$retu.final_cost)) + " (POD)")])] : _vm._e()], 2)]) : _vm._e()]);
  }), 0)])] : _vm._e(), _c('p', {
    staticClass: "mt-4 font-bold mb-4"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepTwo.deliveryServiceTitle')))]), _vm.deliveryServices.length > 0 ? _vm._l(_vm.deliveryServiceByGroup, function (value, key, index) {
    return _c('div', {
      key: index,
      staticClass: "overflow-hidden mb-6 pr-1"
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "id": key
      },
      domProps: {
        "checked": value.isVisible
      }
    }), _c('label', {
      staticClass: "flex justify-between shadow-border-b pb-2 cursor-pointer",
      attrs: {
        "for": key
      },
      on: {
        "click": function click($event) {
          return _vm.expand(key, value.isVisible);
        }
      }
    }, [_c('p', {
      staticClass: "text-sm "
    }, [_vm._v(_vm._s(key))]), _c('span', {
      class: {
        'transform rotate-180': value.isVisible
      }
    }, [_c('Chevron', {
      attrs: {
        "direction": "down"
      }
    })], 1)]), _c('div', {
      staticClass: "sub",
      class: {
        open: value.isVisible
      }
    }, [_vm._l(value.package, function (service, idx) {
      var _vm$selectedPackageDe5, _vm$selectedPackageDe6, _vm$shippingInfo11, _vm$shippingInfo11$re, _vm$shippingInfo12, _vm$shippingInfo12$re, _vm$shippingInfo13, _vm$shippingInfo13$re, _vm$shippingInfo14, _vm$shippingInfo14$re, _vm$shippingInfo17, _vm$shippingInfo17$re, _vm$shippingInfo18, _vm$shippingInfo18$re, _service$package2, _service$package2$ret;

      return _c('div', {
        key: 'service' + idx,
        staticClass: "flex justify-between items-center shadow-border py-2 px-4 rounded-md mb-3 last:mb-0 cursor-pointer",
        class: {
          'bg-primary-100 border border-primary-500': ((_vm$selectedPackageDe5 = _vm.selectedPackageDelivery) === null || _vm$selectedPackageDe5 === void 0 ? void 0 : (_vm$selectedPackageDe6 = _vm$selectedPackageDe5.package) === null || _vm$selectedPackageDe6 === void 0 ? void 0 : _vm$selectedPackageDe6.id) === service.package.id,
          'bg-secondary-100 opacity-50 cursor-not-allowed': parseInt((_vm$shippingInfo11 = _vm.shippingInfo) === null || _vm$shippingInfo11 === void 0 ? void 0 : (_vm$shippingInfo11$re = _vm$shippingInfo11.receiver) === null || _vm$shippingInfo11$re === void 0 ? void 0 : _vm$shippingInfo11$re.weight) < parseInt(service.package.minimum_weight) || parseInt((_vm$shippingInfo12 = _vm.shippingInfo) === null || _vm$shippingInfo12 === void 0 ? void 0 : (_vm$shippingInfo12$re = _vm$shippingInfo12.receiver) === null || _vm$shippingInfo12$re === void 0 ? void 0 : _vm$shippingInfo12$re.weight) > parseInt(service.package.maximum_weight) || parseInt(service.package.final_cost) <= 0
        },
        attrs: {
          "disabled": parseInt((_vm$shippingInfo13 = _vm.shippingInfo) === null || _vm$shippingInfo13 === void 0 ? void 0 : (_vm$shippingInfo13$re = _vm$shippingInfo13.receiver) === null || _vm$shippingInfo13$re === void 0 ? void 0 : _vm$shippingInfo13$re.weight) < parseInt(service.package.minimum_weight) || parseInt((_vm$shippingInfo14 = _vm.shippingInfo) === null || _vm$shippingInfo14 === void 0 ? void 0 : (_vm$shippingInfo14$re = _vm$shippingInfo14.receiver) === null || _vm$shippingInfo14$re === void 0 ? void 0 : _vm$shippingInfo14$re.weight) > parseInt(service.package.maximum_weight) || parseInt(service.package.final_cost) <= 0
        },
        on: {
          "click": function click($event) {
            var _vm$shippingInfo15, _vm$shippingInfo15$re, _vm$shippingInfo16, _vm$shippingInfo16$re;

            parseInt((_vm$shippingInfo15 = _vm.shippingInfo) === null || _vm$shippingInfo15 === void 0 ? void 0 : (_vm$shippingInfo15$re = _vm$shippingInfo15.receiver) === null || _vm$shippingInfo15$re === void 0 ? void 0 : _vm$shippingInfo15$re.weight) >= parseInt(service.package.minimum_weight) && parseInt((_vm$shippingInfo16 = _vm.shippingInfo) === null || _vm$shippingInfo16 === void 0 ? void 0 : (_vm$shippingInfo16$re = _vm$shippingInfo16.receiver) === null || _vm$shippingInfo16$re === void 0 ? void 0 : _vm$shippingInfo16$re.weight) <= parseInt(service.package.maximum_weight) && parseInt(service.package.final_cost) > 0 ? _vm.selectPackage(service.package, service) : null;
          }
        }
      }, [_c('div', {
        staticClass: "flex gap-2 items-center"
      }, [_c('div', {
        staticClass: "flex justify-start items-center w-20"
      }, [service.logo ? _c('img', {
        staticClass: "max-h-12",
        attrs: {
          "src": service.logo,
          "alt": service.name
        }
      }) : _c('LogisticPlaceholder', {
        attrs: {
          "logisticName": service.name
        }
      })], 1), _c('p', {
        staticClass: "text-sm"
      }, [_vm._v(" " + _vm._s(service.package.name) + " "), parseInt(service.package.final_cost) <= 0 ? [_c('p', {
        staticClass: "text-xs text-red-500"
      }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepTwo.unavailableService')))])] : parseInt((_vm$shippingInfo17 = _vm.shippingInfo) === null || _vm$shippingInfo17 === void 0 ? void 0 : (_vm$shippingInfo17$re = _vm$shippingInfo17.receiver) === null || _vm$shippingInfo17$re === void 0 ? void 0 : _vm$shippingInfo17$re.weight) < parseInt(service.package.minimum_weight) ? [_c('p', {
        staticClass: "text-xs"
      }, [_vm._v(" " + _vm._s(_vm.$t('order.createOrder.stepTwo.minimumWeight')) + " " + _vm._s(service.package.name) + " " + _vm._s(service.package.minimum_weight) + " Kg, " + _vm._s(_vm.$t('order.createOrder.stepTwo.adjustWeight')) + " ")])] : parseInt((_vm$shippingInfo18 = _vm.shippingInfo) === null || _vm$shippingInfo18 === void 0 ? void 0 : (_vm$shippingInfo18$re = _vm$shippingInfo18.receiver) === null || _vm$shippingInfo18$re === void 0 ? void 0 : _vm$shippingInfo18$re.weight) > parseInt(service.package.maximum_weight) ? [_c('p', {
        staticClass: "text-xs"
      }, [_vm._v(" " + _vm._s(_vm.$t('order.createOrder.stepTwo.maximumWeight')) + " " + _vm._s(service.package.name) + " " + _vm._s(service.package.maximum_weight) + " Kg, " + _vm._s(_vm.$t('order.createOrder.stepTwo.adjustWeight')) + " ")])] : _vm._e()], 2)]), parseInt(service.package.final_cost) > 0 ? _c('div', {
        staticClass: "flex flex-col gap-1 justify-end items-end"
      }, [_c('p', {
        staticClass: "flex items-center gap-2"
      }, [_c('Time'), _vm._v(" "), _c('span', {
        staticClass: "text-xs text-neutral-500"
      }, [_vm._v(_vm._s(service.package.est_delivery_time_range_min) + " - " + _vm._s(service.package.est_delivery_time_range_max))])], 1), service.package.final_cost !== service.package.shipment_cost ? _c('p', {
        staticClass: "text-xs text-neutral-500 line-through"
      }, [_vm._v(" " + _vm._s(_vm._f("currencyFormat")(service.package.shipment_cost)) + " ")]) : _vm._e(), _c('p', {
        staticClass: "text-sm font-medium"
      }, [_vm._v(" " + _vm._s(_vm._f("currencyFormat")(service.package.final_cost)) + " "), _vm.shippingInfo.is_require_pod ? [_vm._v(" + " + _vm._s(_vm._f("currencyFormat")((_service$package2 = service.package) === null || _service$package2 === void 0 ? void 0 : (_service$package2$ret = _service$package2.return_delivery_service_packages[0]) === null || _service$package2$ret === void 0 ? void 0 : _service$package2$ret.final_cost)) + " ")] : _vm._e()], 2)]) : _vm._e()]);
    }), key === 'Sameday' && _vm.isAfterCutoff ? _c('p', {
      staticClass: "text-red-500 text-sm italic"
    }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepTwo.cutOffNote')))]) : _vm._e()], 2)]);
  }) : [_c('p', {
    staticClass: "text-sm text-center py-4"
  }, [_vm._v("- " + _vm._s(_vm.$t('order.createOrder.stepTwo.noService')) + " -")])]], 2)]), _c('div', {
    staticClass: "w-3/5 p-6 mdmax:w-full mdmax:px-4"
  }, [_c('div', {
    staticClass: "sticky-element"
  }, [_c('div', {
    staticClass: "border border-neutral-300 mb-6 rounded-md bg-white shadow-sm"
  }, [_c('div', {
    staticClass: "p-4 bg-neutral-200 rounded-t-md border-b border-neutral-300 flex items-center gap-2"
  }, [_c('Box2', {
    attrs: {
      "color": "neutral-700",
      "width": "18",
      "height": "18"
    }
  }), _c('p', {
    staticClass: "font-bold text-sm text-neutral-700"
  }, [_vm._v("Rincian Paket")])], 1), _c('div', {
    staticClass: "p-4 flex flex-col gap-3"
  }, [_c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('p', {
    staticClass: "text-sm text-neutral-500"
  }, [_vm._v("Jenis Paket")]), _c('p', {
    staticClass: "text-sm font-medium"
  }, [_vm._v(_vm._s(((_vm$selectedPackageCa = _vm.selectedPackageCategory) === null || _vm$selectedPackageCa === void 0 ? void 0 : _vm$selectedPackageCa.name) || '-'))])]), _c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('p', {
    staticClass: "text-sm text-neutral-500"
  }, [_vm._v("Berat (Input)")]), _c('p', {
    staticClass: "text-sm font-medium"
  }, [_vm._v(_vm._s(((_vm$shippingInfo19 = _vm.shippingInfo) === null || _vm$shippingInfo19 === void 0 ? void 0 : (_vm$shippingInfo19$re = _vm$shippingInfo19.receiver) === null || _vm$shippingInfo19$re === void 0 ? void 0 : _vm$shippingInfo19$re.weight) || 0) + " Kg")])]), (_vm$shippingInfo20 = _vm.shippingInfo) !== null && _vm$shippingInfo20 !== void 0 && (_vm$shippingInfo20$pa = _vm$shippingInfo20.package) !== null && _vm$shippingInfo20$pa !== void 0 && _vm$shippingInfo20$pa.dimension ? _c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('p', {
    staticClass: "text-sm text-neutral-500"
  }, [_vm._v("Dimensi Paket")]), _c('p', {
    staticClass: "text-sm font-medium"
  }, [_vm._v(_vm._s(_vm.shippingInfo.package.dimension.replace(/x/g, ' x ')) + " cm")])]) : _vm._e(), _vm.volumetricWeight > 0 ? _c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('p', {
    staticClass: "text-sm text-neutral-500"
  }, [_vm._v("Berat Volume")]), _c('p', {
    staticClass: "text-sm font-medium"
  }, [_vm._v(_vm._s(_vm.volumetricWeight) + " Kg")])]) : _vm._e()])]), _vm.shippingInfo.is_advance_pickup ? [_c('div', {
    staticClass: "border border-neutral-300 mb-6 rounded-md bg-neutral-200 p-4"
  }, [_c('p', {
    staticClass: "text-xs mb-1"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepTwo.pickupLater')))]), _c('p', {
    staticClass: " font-semibold"
  }, [_vm._v(_vm._s(_vm._f("formatDate")(_vm.shippingInfo.pickup_date)) + ", " + _vm._s((_vm$shippingInfo21 = _vm.shippingInfo) === null || _vm$shippingInfo21 === void 0 ? void 0 : (_vm$shippingInfo21$pi = _vm$shippingInfo21.pickup_slot_id) === null || _vm$shippingInfo21$pi === void 0 ? void 0 : _vm$shippingInfo21$pi.display) + " WIB")])]), _c('div', {
    staticClass: "text-xs p-4 flex items-center gap-2 bg-secondary-100 text-neutral-700 rounded-md mb-6"
  }, [_c('Info', {
    attrs: {
      "width": "24",
      "height": "24",
      "color": "neutral-700"
    }
  }), _vm._v(_vm._s(_vm.$t('order.createOrder.stepTwo.pickupLaterText')) + " ")], 1)] : _vm._e(), _c('p', {
    staticClass: "font-bold mb-4"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepTwo.senderInformation')))]), _c('div', {
    staticClass: "border border-neutral-300 p-4 bg-neutral-200 rounded-md mb-6"
  }, [_c('p', {
    staticClass: "font-bold mb-1"
  }, [_vm._v(_vm._s((_vm$shippingInfo22 = _vm.shippingInfo) === null || _vm$shippingInfo22 === void 0 ? void 0 : (_vm$shippingInfo22$se = _vm$shippingInfo22.sender) === null || _vm$shippingInfo22$se === void 0 ? void 0 : _vm$shippingInfo22$se.sender_name))]), _c('p', {
    staticClass: "text-xs text-neutral-500"
  }, [_vm._v(_vm._s((_vm$shippingInfo23 = _vm.shippingInfo) === null || _vm$shippingInfo23 === void 0 ? void 0 : (_vm$shippingInfo23$se = _vm$shippingInfo23.sender) === null || _vm$shippingInfo23$se === void 0 ? void 0 : _vm$shippingInfo23$se.address))]), (_vm$shippingInfo24 = _vm.shippingInfo) !== null && _vm$shippingInfo24 !== void 0 && (_vm$shippingInfo24$se = _vm$shippingInfo24.sender) !== null && _vm$shippingInfo24$se !== void 0 && _vm$shippingInfo24$se.detail_address ? _c('p', {
    staticClass: "bg-white p-2 mt-4"
  }, [_c('span', {
    staticClass: "block text-xs font-medium mb-1 text-neutral-500"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepTwo.senderDetailAddress')))]), _c('span', {
    staticClass: "text-xs text-neutral-500"
  }, [_vm._v(_vm._s((_vm$shippingInfo25 = _vm.shippingInfo) === null || _vm$shippingInfo25 === void 0 ? void 0 : (_vm$shippingInfo25$se = _vm$shippingInfo25.sender) === null || _vm$shippingInfo25$se === void 0 ? void 0 : _vm$shippingInfo25$se.detail_address))])]) : _vm._e()]), _vm.isPOD ? _c('div', {
    staticClass: "mb-6 flex items-center gap-4 w-full"
  }, [_c('div', {
    staticClass: "text-sm w-full p-4 flex items-center gap-2 bg-secondary-100 text-neutral-700 rounded-md"
  }, [_c('Info', {
    attrs: {
      "width": "24",
      "height": "24",
      "color": "neutral-700"
    }
  }), _vm._v(_vm._s(_vm.$t('order.createOrder.stepTwo.pod')) + " ")], 1)]) : _vm._e(), _vm.isPOD ? _c('div', {
    staticClass: "border border-neutral-300 rounded-md mb-6"
  }, [_vm.selectedPODService ? _c('div', {
    staticClass: "p-4 bg-neutral-200 rounded-tl-md rounded-tr-md flex justify-between items-center mdmax:items-start"
  }, [_c('div', {
    staticClass: "flex items-center gap-6 mdmax:flex-col mdmax:gap-1 mdmax:items-start"
  }, [_vm.selectedPackageDelivery.serviceLogo ? _c('img', {
    staticClass: "w-20",
    attrs: {
      "src": _vm.selectedPackageDelivery.serviceLogo
    }
  }) : _c('LogisticPlaceholder', {
    attrs: {
      "logisticName": _vm.selectedPackageDelivery.serviceName
    }
  }), _c('p', {
    staticClass: "bg-secondary-200 text-xs text-secondary-500 px-2 py-1 rounded-md"
  }, [_vm._v(_vm._s(_vm.selectedPODService.name))])], 1), _c('div', {
    staticClass: "flex flex-col gap-1"
  }, [_c('p', {
    staticClass: "flex items-center gap-2"
  }, [_c('Time'), _c('span', {
    staticClass: "text-xs text-neutral-500"
  }, [_vm._v(_vm._s(_vm.selectedPODService.est_delivery_time_range_min) + " - " + _vm._s(_vm.selectedPODService.est_delivery_time_range_max))])], 1), _vm.selectedPODService.final_cost !== _vm.selectedPODService.shipment_cost ? _c('p', {
    staticClass: "text-xs text-neutral-500 line-through"
  }, [_vm._v(" " + _vm._s(_vm._f("currencyFormat")(_vm.selectedPODService.shipment_cost)) + " ")]) : _vm._e(), _c('p', {
    staticClass: "text-sm font-medium"
  }, [_vm._v(_vm._s(_vm._f("currencyFormat")(_vm.selectedPODService.final_cost)))])])]) : _vm._e(), _c('div', {
    staticClass: "flex items-center gap-5 p-4 justify-between"
  }, [_c('div', {
    staticClass: "flex gap-5 items-center"
  }, [_c('Mail'), _vm._m(0)], 1), _vm.selectedPODService ? _c('Button', {
    attrs: {
      "buttonText": "Ubah Layanan",
      "size": "small"
    },
    on: {
      "action": function action($event) {
        return _vm.togglePOD();
      }
    }
  }) : _vm._e()], 1)]) : _vm._e(), _c('p', {
    staticClass: "font-bold mb-4"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepTwo.receiverInformation')))]), _c('div', {
    staticClass: "border border-neutral-300 p-4 bg-neutral-200 rounded-md mb-6"
  }, [_c('p', {
    staticClass: "font-bold mb-1"
  }, [_vm._v(_vm._s((_vm$shippingInfo26 = _vm.shippingInfo) === null || _vm$shippingInfo26 === void 0 ? void 0 : (_vm$shippingInfo26$re = _vm$shippingInfo26.receiver) === null || _vm$shippingInfo26$re === void 0 ? void 0 : _vm$shippingInfo26$re.name))]), _c('p', {
    staticClass: "text-xs text-neutral-500"
  }, [_vm._v(_vm._s((_vm$shippingInfo27 = _vm.shippingInfo) === null || _vm$shippingInfo27 === void 0 ? void 0 : (_vm$shippingInfo27$re = _vm$shippingInfo27.receiver) === null || _vm$shippingInfo27$re === void 0 ? void 0 : _vm$shippingInfo27$re.addressDetail) + ", " + _vm._s((_vm$shippingInfo28 = _vm.shippingInfo) === null || _vm$shippingInfo28 === void 0 ? void 0 : _vm$shippingInfo28.hub.destination.village) + ", " + _vm._s((_vm$shippingInfo29 = _vm.shippingInfo) === null || _vm$shippingInfo29 === void 0 ? void 0 : _vm$shippingInfo29.hub.destination.area_display) + ".")])]), ((_vm$selectedPackageDe7 = _vm.selectedPackageDelivery) === null || _vm$selectedPackageDe7 === void 0 ? void 0 : (_vm$selectedPackageDe8 = _vm$selectedPackageDe7.package) === null || _vm$selectedPackageDe8 === void 0 ? void 0 : _vm$selectedPackageDe8.service_type) === 'D' && _vm.nearestHubInfo ? [_c('p', {
    staticClass: "font-bold mb-4"
  }, [_vm._v("Layanan Pick up")]), _c('div', {
    staticClass: "border border-neutral-300 p-4 bg-neutral-200 rounded-md mb-6"
  }, [_c('p', {
    staticClass: "text-xs text-neutral-500 mb-1"
  }, [_vm._v("Hub Terdekat")]), _c('p', {
    staticClass: "text-sm font-medium mb-1"
  }, [_vm._v(_vm._s(_vm.nearestHubInfo.name))]), _c('p', {
    staticClass: "text-xs"
  }, [_vm._v(_vm._s(_vm.nearestHubInfo.address))])]), _c('div', {
    staticClass: "border border-neutral-300 p-4 bg-neutral-200 rounded-md mb-6 flex justify-between items-center"
  }, [_vm._m(1), _c('span', {
    staticClass: "cursor-pointer",
    on: {
      "click": function click($event) {
        return _vm.togglePickupVehicle();
      }
    }
  }, [_c('Chevron', {
    attrs: {
      "width": "14",
      "height": "14",
      "direction": "right"
    }
  })], 1)])] : _vm._e()], 2)])]), _c('div', {
    staticClass: "flex items-center p-6 justify-start bg-white gap-4 border-t border-neutral-200 mt-6"
  }, [_c('Button', {
    attrs: {
      "buttonText": _vm.$t('order.createOrder.stepTwo.back'),
      "type": "secondary"
    },
    on: {
      "action": function action($event) {
        return _vm.goBack('shipping');
      }
    }
  })], 1), _c('Modal', {
    attrs: {
      "modalVisible": _vm.showCheckoutModal,
      "id": "checkout-modal",
      "width": "550px",
      "overflowAuto": true
    },
    on: {
      "close": function close($event) {
        _vm.showCheckoutModal = false;
      }
    }
  }, [_c('template', {
    slot: "modal-content"
  }, [_c('div', {
    staticClass: "flex justify-between items-center mb-6 border-b border-neutral-200 pb-4"
  }, [_c('p', {
    staticClass: "font-bold text-xl text-neutral-800"
  }, [_vm._v("Rincian & Pembayaran")])]), _vm.selectedPackageDelivery ? _c('div', {
    staticClass: "border border-gray-300 mb-6 rounded-xl p-4 bg-white shadow-sm"
  }, [_c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('div', {
    staticClass: "flex items-center gap-4"
  }, [_c('div', {
    staticClass: "w-16 h-12 bg-neutral-50 border border-neutral-100 rounded-md flex items-center justify-center p-1"
  }, [_vm.selectedPackageDelivery.serviceLogo ? _c('img', {
    staticClass: "max-h-10 object-contain",
    attrs: {
      "src": _vm.selectedPackageDelivery.serviceLogo
    }
  }) : _c('LogisticPlaceholder', {
    attrs: {
      "logisticName": _vm.selectedPackageDelivery.serviceName
    }
  })], 1), _c('div', [_c('p', {
    staticClass: "font-bold text-neutral-800 text-sm"
  }, [_vm._v(_vm._s(_vm.selectedPackageDelivery.package.name))]), _c('p', {
    staticClass: "text-xs text-neutral-500 mt-1 flex items-center gap-1 font-medium"
  }, [_c('Time', {
    attrs: {
      "width": "12",
      "height": "12",
      "color": "neutral-500"
    }
  }), _vm._v(" " + _vm._s(_vm.selectedPackageDelivery.package.est_delivery_time_range_min) + " - " + _vm._s(_vm.selectedPackageDelivery.package.est_delivery_time_range_max) + " ")], 1)])]), _c('div', {
    staticClass: "text-right"
  }, [_c('p', {
    staticClass: "text-base font-bold text-primary-600"
  }, [_vm._v(_vm._s(_vm._f("currencyFormat")(_vm.selectedPackageDelivery.package.final_cost)))])])]), _vm.isLionParcel() ? _c('div', {
    staticClass: "mt-3 pt-3 border-t border-gray-100 flex justify-between items-center text-xs"
  }, [_c('div', {
    staticClass: "flex items-center gap-1.5 text-neutral-600"
  }, [_c('span', {
    staticClass: "font-semibold text-neutral-700"
  }, [_vm._v("Titik Jemput:")]), _vm.hasValidSenderCoordinate() ? _c('span', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s((_vm$shippingInfo30 = _vm.shippingInfo) === null || _vm$shippingInfo30 === void 0 ? void 0 : (_vm$shippingInfo30$se = _vm$shippingInfo30.sender) === null || _vm$shippingInfo30$se === void 0 ? void 0 : _vm$shippingInfo30$se.location_coordinate))]) : _c('span', {
    staticClass: "text-red-500 font-medium"
  }, [_vm._v("Belum diatur")])]), _c('button', {
    staticClass: "text-primary-600 hover:text-primary-700 font-semibold underline text-xs cursor-pointer",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.openMapModal();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.hasValidSenderCoordinate() ? 'Ubah Lokasi' : 'Pilih Lokasi') + " ")])]) : _vm._e()]) : _vm._e(), _vm.selectedPackageDelivery && _vm.selectedPackageDelivery.package.has_insurace ? _c('div', {
    staticClass: "border border-gray-300 mb-6 rounded-xl overflow-hidden shadow-sm bg-white"
  }, [_c('div', {
    staticClass: "p-4 flex justify-between items-center gap-4",
    class: {
      'border-b border-gray-300 bg-neutral-50': _vm.insurance
    }
  }, [_c('div', {
    staticClass: "flex flex-col flex-1"
  }, [_c('p', {
    staticClass: "text-sm font-bold text-neutral-800"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepTwo.insurance')))]), !_vm.insurance ? _c('p', {
    staticClass: "text-xs text-neutral-500 mt-1"
  }, [_vm._v("Lindungi paket dari kerusakan/kehilangan")]) : _vm._e()]), _c('div', {
    staticClass: "w-12 flex-shrink-0 flex justify-end"
  }, [_c('Toggle', {
    attrs: {
      "id": "insurance"
    },
    model: {
      value: _vm.insurance,
      callback: function callback($$v) {
        _vm.insurance = $$v;
      },
      expression: "insurance"
    }
  })], 1)]), _vm.insurance ? _c('div', {
    staticClass: "p-4 bg-white"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-2 block"
  }, [_vm._v(" " + _vm._s(_vm.$t('order.createOrder.stepTwo.goodsValue')) + " ")]), _c('CurrencyInput', {
    ref: 'priceField',
    attrs: {
      "options": {
        currency: 'IDR'
      },
      "placeholder": _vm.$t('order.createOrder.stepTwo.goodsValuePlaceholder')
    },
    on: {
      "change": function change($event) {
        _vm.goodsValue = $event;
      }
    }
  }), _c('div', {
    staticClass: "mt-4 pt-4 border-t border-dashed border-neutral-200 flex justify-between items-center"
  }, [_c('p', {
    staticClass: "text-sm text-neutral-600"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepTwo.insuranceCost')))]), _c('p', {
    staticClass: "text-sm font-bold text-neutral-800"
  }, [_vm._v(_vm._s(_vm._f("currencyFormat")(_vm.costOfInsurance)))])])], 1) : _vm._e()]) : _vm._e(), _c('div', {
    staticClass: "border border-gray-300 mb-6 rounded-xl p-4 bg-white shadow-sm"
  }, [_c('p', {
    staticClass: "font-bold text-sm mb-4 text-neutral-800"
  }, [_vm._v("Rincian Biaya")]), _c('div', {
    staticClass: "flex justify-between items-center mb-3"
  }, [_c('p', {
    staticClass: "text-sm text-neutral-500"
  }, [_vm._v("Layanan Pengiriman")]), _c('p', {
    staticClass: "text-sm font-medium text-neutral-800"
  }, [_vm._v(_vm._s(_vm._f("currencyFormat")((_vm$selectedPackageDe9 = _vm.selectedPackageDelivery) === null || _vm$selectedPackageDe9 === void 0 ? void 0 : (_vm$selectedPackageDe10 = _vm$selectedPackageDe9.package) === null || _vm$selectedPackageDe10 === void 0 ? void 0 : _vm$selectedPackageDe10.final_cost)))])]), _vm.insurance ? _c('div', {
    staticClass: "flex justify-between items-center mb-3"
  }, [_c('p', {
    staticClass: "text-sm text-neutral-500"
  }, [_vm._v("Biaya Asuransi")]), _c('p', {
    staticClass: "text-sm font-medium text-neutral-800"
  }, [_vm._v(_vm._s(_vm._f("currencyFormat")(_vm.costOfInsurance)))])]) : _vm._e(), (_vm$shippingInfo31 = _vm.shippingInfo) !== null && _vm$shippingInfo31 !== void 0 && _vm$shippingInfo31.is_require_pod && _vm.selectedPODService ? _c('div', {
    staticClass: "flex justify-between items-center mb-3"
  }, [_c('p', {
    staticClass: "text-sm text-neutral-500"
  }, [_vm._v("Biaya Surat Jalan (POD)")]), _c('p', {
    staticClass: "text-sm font-medium text-neutral-800"
  }, [_vm._v(_vm._s(_vm._f("currencyFormat")(_vm.selectedPODService.final_cost)))])]) : _vm._e(), _c('div', {
    staticClass: "border-t border-gray-300 mt-4 pt-4 flex justify-between items-center bg-primary-50 -mx-4 -mb-4 px-4 py-3 rounded-b-xl"
  }, [_c('p', {
    staticClass: "font-bold text-neutral-800"
  }, [_vm._v("Total Pembayaran")]), _c('p', {
    staticClass: "font-bold text-lg text-primary-600"
  }, [_vm._v(_vm._s(_vm._f("currencyFormat")(_vm.totalCost)))])])]), !((_vm$user = _vm.user) !== null && _vm$user !== void 0 && _vm$user.is_upgraded) ? _c('div', {
    staticClass: "mb-6"
  }, [_c('p', {
    staticClass: "font-bold text-sm mb-3 text-neutral-800"
  }, [_vm._v("Metode Pembayaran")]), _c('div', {
    staticClass: "flex gap-4"
  }, [_c('div', {
    staticClass: "border rounded-xl p-4 flex-1 flex items-center justify-center cursor-pointer transition-all duration-200 hover:shadow-md",
    class: {
      'border-primary-500 bg-primary-50 ring-2 ring-primary-500 ring-opacity-50': _vm.paymentType === 'qris',
      'border-gray-300 bg-white hover:border-primary-300': _vm.paymentType !== 'qris'
    },
    on: {
      "click": function click($event) {
        _vm.paymentType = 'qris';
      }
    }
  }, [_c('label', {
    staticClass: "flex flex-col items-center gap-2 w-full cursor-pointer"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.paymentType,
      expression: "paymentType"
    }],
    staticClass: "hidden",
    attrs: {
      "type": "radio",
      "name": "paymentTypeModal",
      "value": "qris"
    },
    domProps: {
      "checked": _vm._q(_vm.paymentType, "qris")
    },
    on: {
      "change": function change($event) {
        _vm.paymentType = "qris";
      }
    }
  }), _c('img', {
    staticClass: "h-6 object-contain",
    attrs: {
      "src": require("@/assets/images/icons/qris.svg")
    }
  }), _c('span', {
    staticClass: "text-xs font-medium text-neutral-600",
    class: {
      'text-primary-700': _vm.paymentType === 'qris'
    }
  }, [_vm._v("QRIS")])])]), _c('div', {
    staticClass: "border rounded-xl p-4 flex-1 flex flex-col justify-center cursor-pointer transition-all duration-200 hover:shadow-md",
    class: {
      'border-primary-500 bg-primary-50 ring-2 ring-primary-500 ring-opacity-50': _vm.paymentType === 'transfer',
      'opacity-50 cursor-not-allowed bg-neutral-50': _vm.totalCost < 80000,
      'border-gray-300 bg-white hover:border-primary-300': _vm.paymentType !== 'transfer' && _vm.totalCost >= 80000
    },
    on: {
      "click": function click($event) {
        _vm.totalCost >= 80000 ? _vm.paymentType = 'transfer' : null;
      }
    }
  }, [_c('label', {
    staticClass: "flex flex-col items-center gap-2 w-full cursor-pointer",
    class: {
      'cursor-not-allowed': _vm.totalCost < 80000
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.paymentType,
      expression: "paymentType"
    }],
    staticClass: "hidden",
    attrs: {
      "disabled": _vm.totalCost < 80000,
      "type": "radio",
      "name": "paymentTypeModal",
      "value": "transfer"
    },
    domProps: {
      "checked": _vm._q(_vm.paymentType, "transfer")
    },
    on: {
      "change": function change($event) {
        _vm.paymentType = "transfer";
      }
    }
  }), _c('span', {
    staticClass: "font-bold text-sm text-neutral-700",
    class: {
      'text-primary-700': _vm.paymentType === 'transfer'
    }
  }, [_vm._v("Bank Transfer")])]), _vm.totalCost < 80000 ? _c('p', {
    staticClass: "text-red-500 text-[10px] mt-1 text-center w-full"
  }, [_vm._v(" Min. Belanja Rp 80.000 ")]) : _vm._e()])])]) : _vm._e(), _vm.isLionParcelMissingCoord ? _c('div', {
    staticClass: "mb-4 p-3 bg-red-50 border border-red-200 rounded-lg flex items-center justify-between text-xs text-red-700"
  }, [_c('span', [_vm._v("Lion Parcel mewajibkan penentuan titik jemput pada peta.")]), _c('button', {
    staticClass: "font-bold underline ml-2 whitespace-nowrap",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.openMapModal();
      }
    }
  }, [_vm._v("Pilih Lokasi")])]) : _vm._e(), _c('div', {
    staticClass: "mt-4 pt-6 pb-2 border-t border-gray-200"
  }, [_c('Button', {
    attrs: {
      "disabled": !((_vm$user2 = _vm.user) !== null && _vm$user2 !== void 0 && _vm$user2.is_upgraded) && !_vm.paymentType || _vm.isLionParcelMissingCoord,
      "buttonText": "Lanjutkan Pembayaran",
      "type": "primary",
      "size": "big_full"
    },
    on: {
      "action": function action($event) {
        return _vm.submitOrderModal();
      }
    }
  })], 1)])], 2), _c('Modal', {
    attrs: {
      "modalVisible": _vm.showConfirmModal,
      "id": "confirm-vip-modal",
      "width": "400px"
    },
    on: {
      "close": function close($event) {
        _vm.showConfirmModal = false;
      }
    }
  }, [_c('template', {
    slot: "modal-content"
  }, [_c('h2', {
    staticClass: "text-lg font-bold mb-4"
  }, [_vm._v("Konfirmasi Pembayaran")]), _c('p', {
    staticClass: "text-sm mb-6"
  }, [_vm._v("Apakah anda ingin melanjutkan proses pembayaran?")]), _c('div', {
    staticClass: "flex justify-end gap-4"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Batal",
      "type": "secondary",
      "size": "small"
    },
    on: {
      "action": function action($event) {
        _vm.showConfirmModal = false;
      }
    }
  }), _c('Button', {
    attrs: {
      "buttonText": "Ya, Bayar",
      "type": "primary",
      "size": "small"
    },
    on: {
      "action": _vm.confirmVIPPayment
    }
  })], 1)])], 2), _c('Modal', {
    attrs: {
      "modalVisible": _vm.showMapModal,
      "width": "600px",
      "id": "map-modal"
    },
    on: {
      "close": _vm.cancelMapModal
    }
  }, [_c('template', {
    slot: "modal-content"
  }, [_c('h3', {
    staticClass: "font-bold text-lg mb-2 text-neutral-800"
  }, [_vm._v("Tentukan Lokasi Penjemputan")]), _c('p', {
    staticClass: "text-sm text-neutral-600 mb-4"
  }, [_vm._v("Lion Parcel mewajibkan koordinat lokasi untuk memproses pengiriman. Silakan pin lokasi pengirim pada peta di bawah ini.")]), _c('div', {
    staticClass: "mb-3 relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.placeSearch,
      expression: "placeSearch"
    }],
    staticClass: "w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 text-sm",
    attrs: {
      "type": "text",
      "placeholder": "Cari lokasi pengirim..."
    },
    domProps: {
      "value": _vm.placeSearch
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.placeSearch = $event.target.value;
      }, _vm.searchPlaces]
    }
  }), _vm.placeSuggestions.length > 0 ? _c('ul', {
    staticClass: "absolute z-20 w-full bg-white border border-gray-200 mt-1 rounded-md shadow-lg max-h-60 overflow-y-auto"
  }, _vm._l(_vm.placeSuggestions, function (prediction, index) {
    return _c('li', {
      key: index,
      staticClass: "px-4 py-2.5 hover:bg-neutral-50 cursor-pointer text-sm border-b border-gray-100 last:border-b-0",
      on: {
        "click": function click($event) {
          return _vm.selectPlaceMap(prediction);
        }
      }
    }, [_vm._v(" " + _vm._s(prediction.description) + " ")]);
  }), 0) : _vm._e()]), _c('div', {
    staticClass: "mb-3 rounded-lg overflow-hidden border border-neutral-300",
    staticStyle: {
      "height": "320px",
      "width": "100%"
    }
  }, [_c('GmapMap', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "center": _vm.mapCenter,
      "zoom": _vm.mapZoom,
      "options": {
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false
      }
    },
    on: {
      "click": _vm.updateMarkerPosition
    }
  }, [_c('GmapMarker', {
    attrs: {
      "position": _vm.mapCenter,
      "draggable": true
    },
    on: {
      "dragend": _vm.updateMarkerPosition
    }
  })], 1)], 1), _c('div', {
    staticClass: "text-xs text-neutral-500 text-center mb-5"
  }, [_c('span', {
    staticClass: "font-semibold text-neutral-700"
  }, [_vm._v("Koordinat:")]), _vm._v(" " + _vm._s(_vm.mapCenter.lat.toFixed(6)) + ", " + _vm._s(_vm.mapCenter.lng.toFixed(6)) + " ")]), _c('div', {
    staticClass: "flex justify-end gap-3"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Batal",
      "type": "secondary",
      "size": "regular"
    },
    on: {
      "action": _vm.cancelMapModal
    }
  }), _c('Button', {
    attrs: {
      "buttonText": _vm.isConfirmingLocation ? 'Menyimpan...' : 'Simpan Lokasi',
      "disabled": _vm.isConfirmingLocation,
      "type": "primary",
      "size": "regular"
    },
    on: {
      "action": _vm.saveLocation
    }
  })], 1)])], 2), _c('Modal', {
    attrs: {
      "modalVisible": _vm.visibleVehicleModal,
      "id": "vehicle-modal",
      "width": "600px"
    },
    on: {
      "close": _vm.togglePickupVehicle
    }
  }, [_c('template', {
    slot: "modal-content"
  }, [_c('VehicleSelection', {
    attrs: {
      "nearestHub": _vm.nearestHubInfo,
      "shippingInfo": _vm.shippingInfo,
      "deliveryServiceId": (_vm$selectedPackageDe11 = _vm.selectedPackageDelivery) === null || _vm$selectedPackageDe11 === void 0 ? void 0 : (_vm$selectedPackageDe12 = _vm$selectedPackageDe11.package) === null || _vm$selectedPackageDe12 === void 0 ? void 0 : _vm$selectedPackageDe12.delivery_service_id
    },
    on: {
      "pickup": _vm.setPickup,
      "close": _vm.togglePickupVehicle
    }
  })], 1)], 2), _c('Modal', {
    attrs: {
      "modalVisible": _vm.visiblePODOptions,
      "id": "pod-modal",
      "width": "600px"
    },
    on: {
      "close": function close($event) {
        return _vm.togglePOD();
      }
    }
  }, [_c('template', {
    slot: "modal-content"
  }, [_c('p', {
    staticClass: "text-left font-bold text-2xl mb-6"
  }, [_vm._v("Layanan " + _vm._s((_vm$selectedPackageDe13 = _vm.selectedPackageDelivery) === null || _vm$selectedPackageDe13 === void 0 ? void 0 : _vm$selectedPackageDe13.serviceName))]), _vm._l((_vm$selectedPackageDe14 = _vm.selectedPackageDelivery) === null || _vm$selectedPackageDe14 === void 0 ? void 0 : (_vm$selectedPackageDe15 = _vm$selectedPackageDe14.package) === null || _vm$selectedPackageDe15 === void 0 ? void 0 : _vm$selectedPackageDe15.return_delivery_service_packages, function (pod, idx) {
    var _vm$temporaryPOD, _vm$selectedPackageDe16, _vm$selectedPackageDe17;

    return _c('div', {
      key: 'pod' + idx,
      staticClass: "flex justify-between items-center shadow-border py-2 px-4 rounded-md mb-3 last:mb-0 cursor-pointer",
      class: {
        'bg-primary-100 border border-primary-500': ((_vm$temporaryPOD = _vm.temporaryPOD) === null || _vm$temporaryPOD === void 0 ? void 0 : _vm$temporaryPOD.id) === pod.id
      },
      on: {
        "click": function click($event) {
          return _vm.selectPOD(pod);
        }
      }
    }, [_c('div', {
      staticClass: "flex gap-2 items-center"
    }, [_c('div', {
      staticClass: "flex justify-start items-center w-20"
    }, [(_vm$selectedPackageDe16 = _vm.selectedPackageDelivery) !== null && _vm$selectedPackageDe16 !== void 0 && _vm$selectedPackageDe16.serviceLogo ? _c('img', {
      staticClass: "max-h-12",
      attrs: {
        "src": (_vm$selectedPackageDe17 = _vm.selectedPackageDelivery) === null || _vm$selectedPackageDe17 === void 0 ? void 0 : _vm$selectedPackageDe17.serviceLogo,
        "alt": pod.name
      }
    }) : _c('LogisticPlaceholder', {
      attrs: {
        "logisticName": pod.name
      }
    })], 1), _c('p', {
      staticClass: "text-sm"
    }, [_vm._v(" " + _vm._s(pod.name) + " ")])]), _c('div', {
      staticClass: "flex flex-col gap-1 justify-end items-end"
    }, [_c('p', {
      staticClass: "flex items-center gap-2"
    }, [_c('Time'), _vm._v(" "), _c('span', {
      staticClass: "text-xs text-neutral-500"
    }, [_vm._v(_vm._s(pod.est_delivery_time_range_min) + " - " + _vm._s(pod.est_delivery_time_range_max))])], 1), pod.final_cost !== pod.shipment_cost ? _c('p', {
      staticClass: "text-xs text-neutral-500 line-through"
    }, [_vm._v(_vm._s(_vm._f("currencyFormat")(pod.shipment_cost)))]) : _vm._e(), _c('p', {
      staticClass: "text-sm font-medium"
    }, [_vm._v(" " + _vm._s(_vm._f("currencyFormat")(pod.final_cost)) + " ")])])]);
  }), _c('div', {
    staticClass: "mt-6 flex justify-end items-center gap-4"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Batal",
      "type": "secondary",
      "size": "regular"
    },
    on: {
      "action": function action($event) {
        return _vm.togglePOD();
      }
    }
  }), _c('Button', {
    attrs: {
      "buttonText": "Ubah",
      "size": "regular"
    },
    on: {
      "action": function action($event) {
        return _vm.applyPOD();
      }
    }
  })], 1)], 2)], 2)], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('p', {
    staticClass: "text-sm font-medium"
  }, [_vm._v("Surat Jalan (POD)")]), _c('p', {
    staticClass: "text-xs text-neutral-500"
  }, [_vm._v("0.5kg")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "flex flex-col gap-1"
  }, [_c('p', {
    staticClass: "text-sm font-medium"
  }, [_vm._v("Pilih Kendaraan Pickup")]), _c('p', {
    staticClass: "text-xs text-neutral-500"
  }, [_vm._v("Lebih dari 50kg, rekomendasikan roda emapat")])]);
}]

export { render, staticRenderFns }